import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showFullScreenPrompt } from '~/components/NativePush';
import { isNativeApp } from '~/core/util/device';
import { NativeContext } from '~/core/native/NativeContextProvider';
import { useShouldSuppressPushPrompt } from '~/components/AccountGetsMarried/hooks/useShouldSuppressPushPrompt';

export const useShowFullScreenPrompt = () => {
  const account = useSelector((state: any) => state.account);
  const { solv_user_date } = account?.summary;
  const dispatch = useDispatch();
  const { shouldShowModalFullScreenPushPrompt, notificationsEnabled } = useContext(NativeContext);
  const shouldSuppressPrompt = useShouldSuppressPushPrompt();

  useEffect(() => {
    if (isNativeApp() && solv_user_date) {
      if (shouldShowModalFullScreenPushPrompt && !notificationsEnabled && !shouldSuppressPrompt) {
        dispatch(showFullScreenPrompt());
      }
    }
  }, [
    dispatch,
    notificationsEnabled,
    shouldShowModalFullScreenPushPrompt,
    solv_user_date,
    shouldSuppressPrompt,
  ]);
};
